import React from "react";

function Contact() {
  return (
    <div className="w-full min-h-screen bg-primary-color py-20 px-6 flex justify-center">
      <div className="max-w-5xl w-full">
        {/* Title */}
        <h1 className="text-center text-4xl md:text-5xl font-bold text-white/70 mb-10">
          Contact Us
        </h1>

        {/* Glassmorphic Card */}
        <div className="backdrop-blur-xl bg-white/10 border border-white/20 shadow-2xl rounded-3xl p-8 md:p-12">
          <p className="text-center text-white/70 text-lg mb-8">
            Have a question? Want to work with us? Just fill out the form
            below—we’d love to hear from you!
          </p>

          {/* Embedded Google Form */}
          <div className="w-full flex justify-center">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSckqSdkz-Dsact3I9YOmy-ulvvg6IKjy3R_SjqVO6RSVZunkg/viewform?embedded=true"
              width="100%"
              height="900"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              className="rounded-xl shadow-lg"
            >
              Loading…
            </iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
